import { useContext } from 'react';

import I18nContext, { I18nContextType } from './I18nContext';

const useI18nContext = (): I18nContextType => {
  const i18nContext = useContext(I18nContext);
  if (!i18nContext) throw new Error(`I18nContext.Provider is not setup properly`);
  return i18nContext;
};

export default useI18nContext;
